import * as Constants from 'constants/Constants';
import axios from 'axios';
import * as Types from './types';
import { SHOW_DANGER_BAR, SHOW_SUCCESS_BAR } from 'store/actions/types';
import { getAccountId } from 'components/Common/Utils/ResourceUtils';
import { isBlank, isEmptyObject } from 'components/Common/Utils/StringUtils';
import { resetAllShipperConfigs, resetShipperConfig } from './visibilityProviderConfigAction';

export const getDataSource = () => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;

        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/datasource`;

        axios
            .get(URL, {
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    account_id: sessionValue.accountId,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                dispatch({
                    type: Types.SET_DATASOURCE,
                    payload: response.data
                });
            });
    };
};

export const getMobilityData = () => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/company/${sessionValue.people_net_id}/vehicles`;

        axios
            .get(URL)
            .then((response) => {
                dispatch({
                    type: Types.GET_MOBILITY_DATA,
                    payload: response.data
                });
            })
            .catch((error) => {
                console.error('Error fetching mobility data:', error);
            })
            .finally(() => {
                dispatch({
                    type: Types.TRUCK_DATA_LOADED,
                    payload: true
                });
                dispatch(toggleSpinner(false));
            });
    };
};

export const getShipmentIdentifiers = (dataSourceId) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/datasource/${dataSourceId}/shipment-identifiers`;

        axios
            .get(URL, {
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    account_id: sessionValue.accountId,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                let payload = {
                    datasourceId: dataSourceId,
                    identifiers: response.data
                };
                dispatch({
                    type: Types.GET_SHIPPER_IDENTIFIERS,
                    payload: payload
                });
            });
    };
};

export const getShipperCodes = (dataSourceId, companyCode) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const tenant_id = sessionValue.tenant_id;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/datasource/${dataSourceId}/shippercodes`;

        const params = {
            companyCode: companyCode
        };
        dispatch({
            type: Types.SHIPPER_CODES_LOADED,
            payload: false
        });

        axios
            .get(URL, {
                headers: {
                    tenant_id,
                    account_id: sessionValue.accountId,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                },
                params
            })
            .then((response) => {
                dispatch({
                    type: Types.GET_SHIPPER_CODES,
                    payload: response.data
                });
            })
            .finally(() => {
                dispatch({
                    type: Types.SHIPPER_CODES_LOADED,
                    payload: true
                });
            });
    };
};

export const getAgreementsByConnectionId =
    (connectionId, selectedAccount) => (dispatch, getState) => {
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;
        const shipperConfigUrl = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration`;
        const { sessionValue } = getState().session;
        const accountUuid =
            sessionValue.userRole === Constants.SYSTEM_ADMIN
                ? selectedAccount?.id
                : sessionValue?.accountUuid;
        const params = { pageSize: Constants.MAX_PAGE_SIZE, query: `accountId==${accountUuid}` };
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: 'Fetching Agreement(s)'
        });
        dispatch(toggleSpinner(true));
        dispatch(resetShipperConfig());
        dispatch(resetAllShipperConfigs());

        Promise.all([axios.get(URL), axios.get(shipperConfigUrl, { params })])
            .then(([agreementsResponse, shipperConfigResponse]) => {
                const agreementsData = agreementsResponse?.data;
                const shipperConfigs = shipperConfigResponse?.data?.items;

                dispatch({
                    type: Types.GET_CONNECTION_AGREEMENTS,
                    payload: updateAgreementData(agreementsData, shipperConfigs)
                });
                dispatch({
                    type: Types.ADD_ALL_SHIPPER_CONFIG,
                    payload: shipperConfigResponse?.data?.items
                });
                if (isEmptyObject(agreementsData)) {
                    dispatch({
                        type: Types.IS_EMPTY_AGREEMENTS,
                        payload: true
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching agreements:', error);
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };

export const updateAgreementData = (agreements, shipperConfigs) => {
    if (shipperConfigs?.length > 0) {
        return Object.keys(agreements).reduce((updatedAgreements, groupName) => {
            updatedAgreements[groupName] = agreements[groupName].map((shipper) => {
                const _shipperConfig = shipperConfigs.find(
                    (shipperConfig) => shipperConfig.shipperCode === shipper.shipper_code
                );
                return {
                    ...shipper,
                    shipperConfig: _shipperConfig
                };
            });
            return updatedAgreements;
        }, {});
    } else {
        return agreements;
    }
};

export const getConnectionsByProviderId = (provider_id, connectionType, session) => (dispatch) => {
    if (isBlank(provider_id) || provider_id === 'undefined') {
        dispatch({
            type: Types.ENABLE_GETCONNECTION_OPERATIONS
        });
        dispatch({
            type: Types.TOGGLE_PROVIDER_CONNECTION_LOADED,
            payload: true
        });
        dispatch(toggleSpinner(false));
        return Promise.resolve(false);
    }

    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/filter`;

    const accountId = !isBlank(session.selected_accountId)
        ? session.selected_accountId
        : session.accountId;
    dispatch({
        type: Types.DISABLE_GETCONNECTION_OPERATIONS
    });
    dispatch({
        type: Types.TOGGLE_PROVIDER_CONNECTION_LOADED,
        payload: false
    });
    const params = {
        account_id: accountId,
        provider_id,
        connectionType: connectionType
    };
    axios
        .get(URL, { params })
        .then((response) => {
            dispatch({
                type: Types.CHANGE_CONNECTIONS,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: Types.ENABLE_GETCONNECTION_OPERATIONS
            });
        })
        .finally(() => {
            dispatch({
                type: Types.TOGGLE_PROVIDER_CONNECTION_LOADED,
                payload: true
            });
            dispatch(toggleSpinner(false));
        });
};

export const getProviderDetails = (provider_id) => (dispatch) => {
    if (isBlank(provider_id) || provider_id === 'undefined') {
        dispatch({
            type: Types.ENABLE_GETCONNECTION_OPERATIONS
        });
        return Promise.resolve(false);
    }

    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/accounts/${provider_id}`;
    axios
        .get(URL)
        .then((response) => {
            dispatch({
                type: Types.GET_SELECTED_PROVIDER_DETAILS,
                payload: response.data
            });
        })
        .finally(() => {
            dispatch({
                type: Types.ENABLE_GETCONNECTION_OPERATIONS
            });
        });
};

export const getConnectionById = (connectionId, operationType) => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}`;
    if (operationType === Constants.CONNECTION_STATUS_CHECK) {
        dispatch({
            type: Types.DISABLE_CONNECTION_STATUS_OPERATIONS
        });
    } else {
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS
        });
    }
    axios
        .get(URL)
        .then((response) => {
            if (response.data?.sharing_agreement === 0) {
                dispatch(resetConnection());
            } else {
                dispatch({
                    type: Types.SET_PROVIDER,
                    payload: response.data
                });
                dispatch({
                    type: Types.CHANGE_CONNECTIONS,
                    payload: response.data
                });
            }
        })
        .finally(() => {
            dispatch({
                type: Types.ENABLE_CONNECTION_STATUS_OPERATIONS
            });
            dispatch({
                type: Types.ENABLE_GETCONNECTION_OPERATIONS
            });
            dispatch({
                type: Types.RESET_SEARCH_TEXT
            });
        });
};

export const getAgreementsByGroupName = (connectionId, groupName) => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;
    const params = {
        groupName
    };
    dispatch({
        type: Types.DISABLE_AGREEMENT_OPERATIONS
    });
    axios
        .get(URL, { params })
        .then((response) => {
            if (response.data.length > 0) {
                dispatch({
                    type: Types.GET_GROUP_AGREEMENTS,
                    payload: response.data
                });
                dispatch({
                    type: Types.IS_EMPTY_AGREEMENTS,
                    payload: false
                });
            } else {
                dispatch({
                    type: Types.REMOVE_GROUP,
                    payload: groupName
                });
                dispatch({
                    type: Types.IS_EMPTY_AGREEMENTS,
                    payload: true
                });
                dispatch(resetUserInputs());
            }
        })
        .finally(() => {
            dispatch({
                type: Types.ENABLE_AGREEMENT_OPERATIONS
            });
            dispatch(toggleSpinner(false));
        });
};

export const saveVisibilityConnections = (connection, id, connectionType) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections`;

        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: 'Creating Agreement'
        });
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS,
            payload: 'Creating Agreement'
        });
        dispatch(toggleSpinner(true));
        axios
            .post(URL, connection, {
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    user_id: sessionValue.userId,
                    company_id: sessionValue.people_net_id,
                    account_id: sessionValue.accountId,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                dispatch(toggleAgreementSaveFlag(true));
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Connection created successfully'
                });
                if (response.data !== undefined && response.data.connection !== undefined) {
                    dispatch(storeNewConnectionId(response.data.connection.id));
                }
                dispatch(toggleCreateConnection(false));
                dispatch(resetUserInputs());
                connectionType === Constants.CONNECTION_TYPES.VENDOR &&
                    dispatch(
                        getConnectionsByProviderId(
                            id,
                            Constants.CONNECTION_TYPES.VENDOR,
                            sessionValue
                        )
                    );
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while creating a Connection'
                    });
                }
            })
            .finally(() => {
                dispatch(toggleSpinner(false));
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch({
                    type: Types.ENABLE_GETCONNECTION_OPERATIONS
                });
            });
    };
};

export const saveAgreement = (connectionId, agreements, statusToggled, operation) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;

        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);
        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        let currentOperation = 'Creating TMS Agreement(s)';
        let successMessage = 'Sharing Agreement created successfully';
        if (statusToggled !== undefined) {
            if (statusToggled) {
                currentOperation = 'Activating Agreement';
            } else {
                currentOperation = 'Deactivating Agreement';
            }
            dispatch({
                type: Types.DISABLE_GETCONNECTION_OPERATIONS
            });
        } else if (agreements[0].agreement_type === Constants.AGREEMENT_TRUCK) {
            currentOperation = 'Creating Mobility Agreement(s)';
        }
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch(toggleSpinner(true));
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: currentOperation
        });
        axios
            .post(URL, agreements, {
                headers
            })
            .then((response) => {
                if (operation === Constants.CREATE_CONNECTION_OPERATION) {
                    successMessage = 'Connection created successfully';
                } else if (operation === Constants.UPDATE_AGREEMENT_OPERATION) {
                    successMessage = 'Sharing Agreement updated successfully';
                }
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: successMessage
                });
                dispatch(getConnectionById(connectionId));
                dispatch(getAgreementsByConnectionId(connectionId));
                dispatch(resetUserInputs());
                if (
                    statusToggled !== undefined ||
                    operation === Constants.CREATE_AGREEMENT_OPERATION
                ) {
                    dispatch(getConnectionById(connectionId, Constants.CONNECTION_STATUS_CHECK));
                }
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    let errorMessage = 'Error while creating Sharing Agreement';
                    if (operation === Constants.CREATE_CONNECTION_OPERATION) {
                        errorMessage = 'Error while creating Connection';
                    } else if (operation === Constants.UPDATE_AGREEMENT_OPERATION) {
                        errorMessage = 'Error while updating Sharing Agreement';
                    }
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: errorMessage
                    });
                }
            })
            .finally(() => {
                dispatch(toggleSpinner(false));
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch({
                    type: Types.ENABLE_GETCONNECTION_OPERATIONS
                });
            });
    };
};

export const updateAgreement = (connectionId, provider, groupName, agreements, statusToggled) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/agreements`;

        const params = {
            groupName
        };

        let currentOperation = 'Creating TMS Agreement(s)';
        let successMessage = 'Sharing Agreement updated successfully';
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS
        });
        dispatch(toggleSpinner(true));
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: currentOperation
        });
        if (statusToggled) {
            currentOperation = 'Activating Agreement';
        } else {
            currentOperation = 'Deactivating Agreement';
        }
        axios
            .put(URL, agreements, {
                params,
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    user_id: sessionValue.userId,
                    provider: provider,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: successMessage
                });
                if (response.data.length > 0) {
                    dispatch(getAgreementsByGroupName(connectionId, agreements[0].group_name));
                } else {
                    dispatch(toggleSpinner(false));
                    dispatch({
                        type: Types.ENABLE_AGREEMENT_OPERATIONS
                    });
                }
                dispatch(getConnectionById(connectionId, Constants.CONNECTION_STATUS_CHECK));
                dispatch(resetUserInputs());
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    let errorMessage = 'Error while updating Sharing Agreement';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: errorMessage
                    });
                }
            })
            .finally(() => {
                dispatch(toggleSpinner(false));
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch({
                    type: Types.ENABLE_GETCONNECTION_OPERATIONS
                });
            });
    };
};

export const deleteAgreement = (
    connectionId,
    provider,
    agreementIdList,
    groupName,
    agreementType,
    groupDelete,
    deleteAllVehicles
) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;
        let currentOperationMessage = 'Removing Shipper code(s)';
        let message = 'Sharing Agreement updated successfully';
        if (agreementType === Constants.AGREEMENT_TRUCK) {
            currentOperationMessage = 'Deleting Agreement(s)';
        }

        if (groupDelete) {
            message = 'Sharing Agreement Deleted successfully';
            dispatch(toggleSpinner(true));
        }
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: currentOperationMessage
        });
        const params = deleteAllVehicles
            ? { groupName }
            : { agreementIds: agreementIdList?.join(',') };
        axios
            .delete(URL, {
                params,
                headers: {
                    account_id: sessionValue.accountId,
                    tenant_id: sessionValue.tenant_id,
                    user_id: sessionValue.userId,
                    company_id: sessionValue.people_net_id,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                if (!groupDelete) {
                    if (groupName === Constants.GPS_ONLY) {
                        dispatch(updateDeletedAgreements(agreementIdList));
                    } else {
                        dispatch(checkAndClearEditedAgreements(groupName, agreementIdList));
                    }
                } else {
                    dispatch(getConnectionById(connectionId, Constants.CONNECTION_STATUS_CHECK));
                }
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: message
                });
                dispatch(getAgreementsByConnectionId(connectionId));
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while deleting the Sharing Agreement'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };
};

export const updateVisibilityConnectionStatus = (connectionId, updatedStatus) => {
    return (dispatch, getState) => {
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}`;
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: 'Updating Connection'
        });
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS
        });
        dispatch(toggleSpinner(true));
        const params = {
            status: updatedStatus
        };

        axios
            .patch(url, params)
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Connection status updated successfully'
                });
                dispatch(getConnectionById(connectionId));
                dispatch(getAgreementsByConnectionId(connectionId));
            })
            .catch(() => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Error while updating connection status'
                });
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch({
                    type: Types.ENABLE_GETCONNECTION_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };
};

export const updateIndividualVendorAgreement = (connection, type, updatedStatus) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connection?.id}/agreements`;
        const params = {
            groupName: type,
            status: updatedStatus
        };
        axios
            .patch(url, params)
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Agreement updated successfully'
                });
                dispatch(
                    getConnectionsByProviderId(
                        connection?.provider_id,
                        connection?.type,
                        sessionValue
                    )
                );
                dispatch(
                    getAgreementsByProviderIdAndAccountId(
                        connection.provider_id,
                        !isBlank(sessionValue?.selected_accountId)
                            ? sessionValue?.selected_accountId
                            : sessionValue?.accountId
                    )
                );
            })
            .catch(() => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Error while updating agreement status'
                });
            });
    };
};

export const updateIndividualVisibilityAgreement = (connectionId, type, updatedStatus) => {
    return (dispatch) => {
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;
        const params = {
            groupName: type,
            status: updatedStatus
        };
        axios
            .patch(url, params)
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Sharing Agreement updated successfully'
                });
                dispatch(getConnectionById(connectionId));
                dispatch(getAgreementsByConnectionId(connectionId));
            })
            .catch(() => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Error while updating agreement status'
                });
            });
    };
};

export const getGroupNames = (name) => (dispatch) => {
    const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/groups`;

    dispatch({
        type: Types.SHIPPER_GROUP_LOADED,
        payload: false
    });

    const headers = {
        Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
    };
    const params = {
        name
    };

    axios
        .create()
        .get(url, { headers, params })
        .then((res) => {
            dispatch({
                type: Types.GET_GROUPNAMES,
                payload: res.data
            });
            dispatch({
                type: Types.SHIPPER_GROUP_LOADED,
                payload: true
            });
        });
};

export const toggleAgreementSaveFlag = (flag) => (dispatch) => {
    dispatch({
        type: Types.AGREEMENT_SAVE_FLAG,
        payload: flag
    });
};

export const toggleCreateConnection = (showCreateConnection) => (dispatch) => {
    dispatch({
        type: Types.TOGGLE_SHOW_CREATE_CONNECTION,
        payload: showCreateConnection
    });
};

export const sendSelectedDataSource = (data) => (dispatch) => {
    dispatch({
        type: Types.GET_SELECTED_DATA_SOURCE,
        payload: data
    });
};

export const setEmptyAgreements = (data) => (dispatch) => {
    dispatch({
        type: Types.IS_EMPTY_AGREEMENTS,
        payload: data
    });
};

export const toggleSpinner = (showSpinner) => (dispatch) => {
    dispatch({
        type: Types.TOGGLE_SPINNER,
        payload: showSpinner
    });
};

export const resetConnection = () => (dispatch) => {
    dispatch({
        type: Types.CHANGE_CONNECTIONS,
        payload: {}
    });
};

export const updateScrollIntoGroup = (groupName) => (dispatch) => {
    dispatch({
        type: Types.OPEN_GROUP,
        payload: groupName
    });
};

export const discardChanges = (discard) => (dispatch) => {
    dispatch({
        type: Types.DISCARD_CHANGES,
        payload: discard
    });
};

export const updateNewShipper = (data) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_NEW_SHIPMENT_AGREEMENT,
        payload: data
    });
};

export const updateNewTruck = (data) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_NEW_TRUCK_AGREEMENT,
        payload: data
    });
};

export const toggleAgreementEditStatus = (status) => (dispatch) => {
    dispatch({
        type: Types.TOGGLE_AGREEMENT_EDIT_MODE,
        payload: status
    });
};

export const setFromCreateFlow = (value) => (dispatch) => {
    dispatch({
        type: Types.SET_FROM_CREATE_FLOW,
        payload: value
    });
};

export const updateNewAgreementGroup = (agreementGroupData) => {
    return {
        type: Types.UPDATE_NEW_AGREEMENT_GROUP,
        payload: agreementGroupData
    };
};

export const updateEditedAgreements = (editedAgreements) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_EDIT_EXISTING_SHIPMENT_AGREEMENT,
        payload: editedAgreements
    });
};

export const updateFilteredAgreements = (filteredAgreements) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_FILTERED_AGREEMENTS,
        payload: filteredAgreements
    });
};

export const updateDeletedAgreements = (deletedAgreements) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_DELETED_AGREEMENTS,
        payload: deletedAgreements
    });
};

export const checkAndClearEditedAgreements = (groupName, deletedAgreements) => (dispatch) => {
    dispatch({
        type: Types.CHECK_CLEAR_EDITED_AGREEMENTS,
        payload: {
            groupName,
            deletedAgreements
        }
    });
};

export const updateExistingAgreementGroup = (agreementGroupData) => {
    return {
        type: Types.UPDATE_EXISTING_AGREEMENT_GROUP,
        payload: agreementGroupData
    };
};

export const storeNewConnectionId = (connectionId) => (dispatch) => {
    dispatch({
        type: Types.STORE_NEW_CONNECTION_ID,
        payload: connectionId
    });
};

export const clearGroupNames = () => (dispatch) => {
    dispatch({
        type: Types.CLEAR_GROUPNAMES,
        payload: []
    });
};

export const resetShipperGroupNameLoaded = () => (dispatch) => {
    dispatch({
        type: Types.SHIPPER_GROUP_LOADED,
        payload: false
    });
};

export const addNewShipper = (data) => (dispatch) => {
    dispatch({
        type: Types.ADD_NEW_SHIPMENT_AGREEMENT,
        payload: data
    });
};

export const clearShipperCodes = () => (dispatch) => {
    dispatch({
        type: Types.GET_SHIPPER_CODES,
        payload: []
    });
};

export const clearShipmentIdentifiers = () => (dispatch) => {
    dispatch({
        type: Types.GET_SHIPPER_IDENTIFIERS,
        payload: []
    });
};

export const resetShipperCodeLoaded = () => (dispatch) => {
    dispatch({
        type: Types.SHIPPER_CODES_LOADED,
        payload: false
    });
};

export const addNewTruck = (data) => (dispatch) => {
    dispatch({
        type: Types.ADD_NEW_TRUCK,
        payload: data
    });
};

export const newTruckAgreements = (data) => (dispatch) => {
    dispatch({
        type: Types.ADD_NEW_TRUCK_AGREEMENT,
        payload: data
    });
};

export const removeTruck = (data) => (dispatch) => {
    dispatch({
        type: Types.REMOVE_TRUCK,
        payload: data
    });
};

export const clearTruck = () => (dispatch) => {
    dispatch({
        type: Types.CLEAR_TRUCK
    });
};

export const updateTruck = (truckRequest) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_TRUCK,
        payload: truckRequest
    });
};

export const updateSearchText = (searchText) => {
    return {
        type: Types.UPDATE_SEARCH_TEXT,
        payload: searchText
    };
};

export const showAddTruck = (show) => (dispatch) => {
    if (show) {
        dispatch({
            type: Types.SHOW_ADD_TRUCK
        });
    } else {
        dispatch({
            type: Types.HIDE_ADD_TRUCK
        });
    }
};

export const resetUserInputs = () => (dispatch) => {
    dispatch(updateEditedAgreements({}));
    dispatch(updateExistingAgreementGroup({}));
    dispatch(updateNewAgreementGroup(Constants.AGREEMENT_GROUP_FIELD));
    dispatch(updateNewShipper({}));
    dispatch(discardChanges(false));
    dispatch(toggleCreateConnection(false));
    dispatch(toggleAgreementEditStatus({}));
    dispatch(updateNewTruck([]));
    dispatch({
        type: Types.RESET_SEARCH_TEXT
    });
};

export const resetAllData = () => (dispatch) => {
    dispatch(resetUserInputs());
    dispatch(resetConnection());
    dispatch({
        type: Types.SET_PROVIDER,
        payload: {}
    });
    dispatch({
        type: Types.GET_SELECTED_PROVIDER_DETAILS,
        payload: {}
    });
    dispatch({
        type: Types.GET_CONNECTION_AGREEMENTS,
        payload: {}
    });
};

export const setCloseAllPanel = (flag) => (dispatch) => {
    dispatch({
        type: Types.SET_CLOSE_ALL_PANEL,
        payload: flag
    });
};

export const toggleEventsLoaded = (flag) => (dispatch) => {
    dispatch({
        type: Types.TOGGLE_EVENTS_LOADED,
        payload: flag
    });
};

export const getTrustCenterEventTypes = (providerType, destinationAccountId) => {
    return (dispatch) => {
        const eventTypeUrl = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/event-types`;
        const params = {
            eventType: providerType,
            destinationAccountId
        };
        dispatch(toggleEventsLoaded(false));
        axios.get(eventTypeUrl, { params }).then(({ data: payload }) => {
            dispatch({
                type: Types.GET_TRUSTCENTER_EVENT_TYPES,
                payload
            });
            dispatch(toggleEventsLoaded(true));
        });
    };
};

export const updateOtherAgreements = (connectionId, providerId, agreementObj) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: 'Updating Agreement'
        });
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS
        });
        dispatch(toggleSpinner(true));
        const headers = {
            account_id: sessionValue.accountId,
            tenant_id: sessionValue.tenant_id,
            user_id: sessionValue.userId,
            company_id: sessionValue.people_net_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };

        axios
            .post(url, agreementObj, { headers })
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Agreement updated successfully'
                });
                dispatch(
                    getAgreementsByProviderIdAndAccountId(
                        providerId,
                        !isBlank(sessionValue.selected_accountId)
                            ? sessionValue.selected_accountId
                            : sessionValue.accountId
                    )
                );
                dispatch(
                    getConnectionsByProviderId(
                        providerId,
                        Constants.CONNECTION_TYPES.VENDOR,
                        sessionValue
                    )
                );
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while updating Agreement'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };
};

export const getAgreementsByProviderIdAndAccountId = (providerId, accountId) => (dispatch) => {
    if (isBlank(accountId) || isBlank(providerId) || providerId === 'undefined') {
        dispatch({
            type: Types.ENABLE_AGREEMENT_OPERATIONS
        });
        dispatch(toggleSpinner(false));
        return Promise.resolve(false);
    }
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/agreements?account_id=${accountId}&provider_id=${providerId}`;
    dispatch({
        type: Types.DISABLE_AGREEMENT_OPERATIONS
    });
    dispatch({
        type: Types.AGREEMENT_CURRENT_OPERATION,
        payload: 'Fetching Agreement(s)'
    });
    dispatch(toggleSpinner(true));
    axios
        .get(URL)
        .then((response) => {
            dispatch({
                type: Types.GET_CONNECTION_AGREEMENTS,
                payload: response.data
            });
        })
        .finally(() => {
            dispatch({
                type: Types.ENABLE_AGREEMENT_OPERATIONS
            });
            dispatch(toggleSpinner(false));
        });
};

export const updateOtherConnectionStatus = (connection, updatedStatus) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connection?.id}`;
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch({
            type: Types.AGREEMENT_CURRENT_OPERATION,
            payload: 'Updating Connection'
        });
        dispatch({
            type: Types.DISABLE_GETCONNECTION_OPERATIONS
        });
        dispatch(toggleSpinner(true));

        const params = {
            status: updatedStatus
        };

        axios
            .patch(url, params)
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Connection status updated successfully'
                });
                dispatch(
                    getConnectionsByProviderId(
                        connection?.provider_id,
                        connection?.type,
                        sessionValue
                    )
                );
                dispatch(
                    getAgreementsByProviderIdAndAccountId(
                        connection?.provider_id,
                        !isBlank(sessionValue?.selected_accountId)
                            ? sessionValue?.selected_accountId
                            : sessionValue?.accountId
                    )
                );
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while updating connection status'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };
};
